import React from 'react'
import Step, { StepProps } from './Step'
import { Flex, Show } from '@/components/core'
import { classNameBuilder } from '@/helpers'

export interface StepIndicatorProps {
  steps: Omit<StepProps, 'state'>[]
  activeIndex?: number
  className?: string
}
const StepIndicator: React.FC<StepIndicatorProps> = ({
  steps,
  activeIndex = -1,
  className
}) => {
  return (
    <Flex
      className={classNameBuilder(
        'flex-row justify-center lg:flex-col',
        className
      )}
    >
      {steps?.map((stepProps, index, arr) => {
        const isLastStep = index + 1 === arr.length
        return (
          <Flex
            key={stepProps.text}
            className="flex-col max-lg:flex-row max-lg:items-center"
          >
            <Step
              {...stepProps}
              state={
                activeIndex === index
                  ? 'current'
                  : activeIndex > index
                    ? 'done'
                    : 'disabled'
              }
            />
            <Show when={!isLastStep} key={`separator-${stepProps.text}`}>
              <Flex
                className={classNameBuilder(
                  'mx-1 h-6 w-[1px] max-lg:h-[1px] max-lg:w-6 max-md:mb-4 md:mx-3 lg:my-4 lg:ml-[20px]',
                  activeIndex === index
                    ? 'bg-electric-indigo-50/50'
                    : 'bg-electric-indigo-50/20',
                  'transition duration-300 before:transition before:duration-300'
                )}
              />
            </Show>
          </Flex>
        )
      })}
    </Flex>
  )
}

export default StepIndicator
